import(/* webpackMode: "eager", webpackExports: ["GeneralInfoTemplate"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\general-info-template.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RevealOnScroll"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\reveal-on-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisitorCount"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\visitor-count.tsx");
;
import(/* webpackMode: "eager" */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\node_modules\\next\\dist\\client\\script.js");
